module.exports = __webpack_public_path__ + "static/media/AmazonGraphics6.958599b2.jpg";